<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Nom du fichier dans src/assets/icons/ (sans extension). */
    name: string
    size?: number | string
    alt?: string
  }>(),
  { size: 30, alt: '' },
)

const modules = import.meta.glob<{ default: string }>(
  '@/assets/icons/*.{png,webp,svg,jpg}',
  { eager: true },
)

const sources: Record<string, string> = Object.fromEntries(
  Object.entries(modules).map(([path, mod]) => {
    const file = path.split('/').pop() as string
    const name = file.replace(/\.(png|webp|svg|jpe?g)$/i, '')
    return [name, mod.default]
  }),
)

const src = computed(() => sources[props.name])
</script>

<template>
  <img
    v-if="src"
    :src="src"
    :alt="alt"
    :width="size"
    :height="size"
    decoding="async"
    loading="lazy"
    class="picto"
  />
</template>

<style scoped>
.picto {
  display: block;
  object-fit: contain;
}
</style>
